import React from 'react';
import PropTypes from 'prop-types';
import ScheduleTypeCellParamTemplateContainer from 'features/schedules/scheduleTypeCellParamTemplates/edit/components/ScheduleTypeCellParamTemplateContainer';
import { Button } from '@totalsoft/rocket-ui';
import { seasonalityTemplateModalVar } from './variables';
import { useTranslation } from 'react-i18next';

const FinancialProductSeasonalityTemplateViewComponent = ({templateId}) => {
    const { t } = useTranslation();
return (
    <>
        <ScheduleTypeCellParamTemplateContainer scheduleTypeCellParamTemplateId={templateId} canWrite={false} />
        <Button onClick={() => seasonalityTemplateModalVar({ open: false })}>{t('Close')}</Button>
    </>
);
}

FinancialProductSeasonalityTemplateViewComponent.propTypes = {
    templateId: PropTypes.number.isRequired
};
      
export default FinancialProductSeasonalityTemplateViewComponent;
